import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { environment } from '../../environments/environment';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: {
      //loadPath: (language: string) => `${environment.static.translate}${language}.json`,
      loadPath: (language: string) => `/static/locales/${language}.json`,
      allowMultiLoading: false,
      queryStringParams: {},
    },
    detection: {
      htmlTag: document.documentElement,
    },
    supportedLngs: ['es'],
    lng: 'es',
    fallbackLng: 'es',
    ns: [''],
    defaultNS: '',
    debug: false, // environment.debug
    interpolation: {
      escapeValue: false, // react already safes from xss
      formatSeparator: ',',
    },
    react: {
      wait: true,
    },
  });

// WCAG 3.1.1: el atributo lang del documento debe reflejar siempre el idioma
// activo, tambien cuando la persona usuaria lo cambia en caliente.
const syncDocumentLang = (language?: string): void => {
  if (!language) {
    return;
  }
  document.documentElement.setAttribute('lang', language.slice(0, 2));
};

syncDocumentLang(i18n.language);
i18n.on('languageChanged', syncDocumentLang);

export default i18n;
